import * as types from '../action-types';

const updateShouldStorePaymentDetailsConsent = paymentMethodType => ({
  type: types.UPDATE_SHOULD_STORE_PAYMENT_DETAILS_CONSENT,
  paymentMethodType,
});

export default updateShouldStorePaymentDetailsConsent;
